import React from 'react';
import Grid from '@mui/material/Grid';
import { Typography } from '@mui/material';

const ErrorComponent = ({ error }) => {
  return (
    <Grid
      container
      spacing={0}
      direction='column'
      alignItems='center'
      justify='center'
      style={{ minHeight: '100vh' }}>
      <>
        <Typography variant='h6'>
          An Error Occurred: {error.errorCode}
        </Typography>
      </>
    </Grid>
  );
};

export default ErrorComponent;
